import { Activity, Users } from 'lucide-react'

export const P2P_MARKETS_PER_PAGE = 12
export const P2P_MARKETS_SKELETON_COUNT = 8
export const P2P_HOLDERS_LIMIT = 5
export const P2P_ACTIVITIES_PER_PAGE = 5

export const P2P_MARKET_SORT_OPTIONS = [
	{ value: '24h_volume', label: '24H Volume' },
	{ value: 'created_at', label: 'Created At' },
	{ value: 'liquidity', label: 'Liquidity' },
	{ value: 'total_volume', label: 'Total Volume' },
] as const

export const P2P_MARKET_STATUS_OPTIONS = [
	{ value: 'all', label: 'All' },
	{ value: 'active', label: 'Active' },
	{ value: 'resolved', label: 'Resolved' },
] as const

export const P2P_PERCENT_DATE_RANGES = [
	{ label: '1D', rangeMs: 24 * 60 * 60 * 1000 },
	{ label: '1W', rangeMs: 7 * 24 * 60 * 60 * 1000 },
	{ label: '1M', rangeMs: 30 * 24 * 60 * 60 * 1000 },
	{ label: 'All', rangeMs: undefined },
] as const

export const P2P_OPTION_FALLBACK_COLORS = ['#158AE9', '#E38110', '#00CFE8', '#B5FD4F', '#A855F7', '#EC4899'] as const

export const P2P_DETAIL_TAB_HOLDERS = 'holders' as const
export const P2P_DETAIL_TAB_ACTIVITY = 'activity' as const

export const P2P_DETAIL_TABS = [
	{ id: P2P_DETAIL_TAB_HOLDERS, label: 'Top Holders', icon: Users },
	{ id: P2P_DETAIL_TAB_ACTIVITY, label: 'Activity', icon: Activity },
] as const

export type P2pDetailTabId = (typeof P2P_DETAIL_TABS)[number]['id']
